import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  mainContainer: {
    fontSize: 12,
    marginLeft: 30,
  },
}));
